// form
import { useFormContext, Controller, ControllerRenderProps, FieldValues } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import { HTMLInputTypeAttribute } from 'react';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  type?: HTMLInputTypeAttribute;
  onAltEnter?: () => void;
}

export default function RHFTextField({
  name,
  onAltEnter,
  type,
  ...other
}: IProps & TextFieldProps) {
  const { control } = useFormContext();

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter' && (e.altKey || e.metaKey)) {
      if (onAltEnter) {
        e.preventDefault();

        onAltEnter();
      }
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: ControllerRenderProps<FieldValues, string>
  ) => {
    if (type === 'number') {
      e.target.value = zenkakuToHankaku(e.target.value);
    }
    field.onChange(e);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          onChange={(e) => handleChange(e, field)}
          onBlur={field.onBlur}
          value={field.value}
          fullWidth
          error={!!error}
          helperText={error?.message}
          type={type}
          {...other}
          onKeyDown={handleKeyPress}
        />
      )}
    />
  );
}

function zenkakuToHankaku(str: string) {
  return str.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
}
